import { G } from "../../design/tokens";

export default function StatCard({ icon, label, value, accent = "#2563EB" }) {
  return (
    <div style={{ background: G.glass, border: `1px solid ${G.glassBrd}`, borderRadius: 14, padding: "20px 24px", display: "flex", alignItems: "center", gap: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.25)", flex: 1 }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: `${accent}1A`, border: `1px solid ${accent}44`, display: "flex", alignItems: "center", justifyContent: "center", color: accent, flexShrink: 0 }}>{icon}</div>
      <div>
        <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 26, fontWeight: 700, color: "#fff", lineHeight: 1 }}>{value}</div>
        <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.35)", marginTop: 5, letterSpacing: 0.5 }}>{label}</div>
      </div>
    </div>
  );
}
